import { Injectable } from '@angular/core';
import { WebrqaResponse } from '../model/reservation.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  PATH = 'api/info';

  constructor(private http: HttpClient) {}

  getVersion(): Observable<WebrqaResponse> {
    return this.http.get<WebrqaResponse>(`${this.PATH}`);
  }
}
